import ConstructionControllers from "../../../../pages-v1/ConstructionControllers";

export const Page = ConstructionControllers;
